export default __webpack_public_path__ + "static/media/gallery_13.a38f6462.jpg";